/**
 * **새 세계 첫 입장 카드 — 지난 세계의 명예의 전당** (UNI-Q193 · DESIGN 14.273).
 *
 * 서버가 보낼 때만 뜬다 — 지난 세계를 건너온 계정이 이 세계에 처음 들어온 한 번(`do.ts` 입장 경로의 `playedWorld` 표식).
 * 처음 온 사람에게는 서버가 안 보낸다.
 *
 * ⚠ **게임을 막지 않는다**(절대규칙 4 — 접속 뒤 10초 안에 사냥). 바깥 상자는 입력을 받지 않고 카드만 받는다.
 *   카드 밖을 누르거나 키를 누르면 그 입력은 그대로 게임으로 가고 카드는 닫힌다(스토리 카드와 같은 결).
 *   20초 뒤 스스로 닫힌다. 스토리 카드가 떠 있으면 그것이 닫힌 뒤에 뜬다(두 카드가 겹치지 않게).
 * 한 세계 칸은 명예의 전당 패널과 같은 `hallWorldBlock` 이다 — 카드와 패널이 다른 말을 하지 않게.
 */
import { hallWorldBlock, selectWorld } from './panels/hall.js';

export const HALL_CARD_MS = 20000;

export function hallCardHtml(entry) {
  return '<div class="hall-card"><div class="hall-card-head"><b>지난 세계의 명예의 전당</b>'
    + '<button type="button" data-hall-close aria-label="명예의 전당 카드 닫기">×</button></div>'
    + hallWorldBlock(entry, { full: false })
    + '<div class="hall-card-actions"><span class="qt">지난 기록은 명예의 전당에 남는다.</span>'
    + '<button type="button" data-hall-open>지난 세계 기록 보기</button></div></div>';
}

/** 입력·타이머를 주입받는다 — 실제 동작을 따로 검증할 수 있게(story.js 와 같은 결) */
export function createHallCard({ root, events = window, schedule = setTimeout, cancel = clearTimeout,
  storyOpen = () => false, onOpen = () => {} } = {}) {
  let open = false, timer = null, waiting = null;
  function close() {
    if (waiting !== null) { cancel(waiting); waiting = null; }
    if (timer !== null) { cancel(timer); timer = null; }
    if (!open) return false;
    open = false;
    events.removeEventListener('pointerdown', outside, true);
    events.removeEventListener('keydown', key, true);
    root.classList.remove('on');
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = '';
    return true;
  }
  // 캡처 단계에서 보기만 한다 — 입력은 막지 않고 그대로 게임(캔버스·버튼)으로 간다
  function outside(event) { if (open && !root.contains(event.target)) close(); }
  function key(event) {
    if (!open || event.isComposing || event.target?.closest?.('input,textarea,select,[contenteditable="true"]')) return;
    close();
  }
  function present(entry) {
    root.innerHTML = hallCardHtml(entry);
    root.classList.add('on');
    root.setAttribute('aria-hidden', 'false');
    open = true;
    root.querySelector('[data-hall-close]')?.addEventListener('click', () => close());
    root.querySelector('[data-hall-open]')?.addEventListener('click', () => { selectWorld(entry.world); close(); onOpen(); });
    events.addEventListener('pointerdown', outside, true);
    events.addEventListener('keydown', key, true);
    timer = schedule(close, HALL_CARD_MS);
  }
  /** 스토리 카드가 떠 있으면 1초마다 다시 보고(최대 30번) 닫힌 뒤에 뜬다 */
  function show(entry, tries = 30) {
    if (!root || !entry) return false;
    close();
    if (storyOpen() && tries > 0) {
      waiting = schedule(() => { waiting = null; show(entry, tries - 1); }, 1000);
      return true;
    }
    present(entry);
    return true;
  }
  return { show, close, isOpen: () => open };
}
